import {
  BaseFileExtension,
  BaseMimeType,
  FALLBACK_MIME,
  FallbackMimeType,
} from '../enums/base-available-file-type.enum';
import { EXTENSION_TO_MIME } from '../constants/base-file-types';

export const baseGetMimeTypeByFileName = (fileName: string) => {
  if (fileName.endsWith(`.${BaseFileExtension.png}`)) {
    return BaseMimeType.png;
  }
  if (fileName.endsWith(`.${BaseFileExtension.jpeg}`) || fileName.endsWith(`.${BaseFileExtension.jpg}`)) {
    return BaseMimeType.jpeg;
  }

  return BaseMimeType.pdf;
};

export const getMimeFromFile = (file: File): BaseMimeType | FallbackMimeType => {
  if (file.type) {
    return file.type.toLowerCase() as BaseMimeType;
  }

  const extension = (file.name.toLowerCase().split('.').pop() ?? '') as BaseFileExtension;
  return EXTENSION_TO_MIME[extension] ?? FALLBACK_MIME;
};
